import { applySpec, prop, compose, map, lt } from "ramda";
import { buildAvatarSrc } from "../../helpers/buildAvatarSrc";

const Profile = applySpec({
  avatarSrc: compose(buildAvatarSrc, prop("avatar")),
  username: prop("username"),
});

const Account = applySpec({
  externalId: prop("external_id"),
});

const UserPremiumStatus = applySpec({
  isPremium: compose(lt(0), prop("length"), map(prop("benefit"))),
});

export { Profile, Account, UserPremiumStatus };
